import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import TBLProdutos from "../../../components/TBLProdutos";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PDFDetalhesPedido from "../../../pdfs/PDFDetalhesPedido";
import * as moment from "moment";
import "moment/locale/pt-br";
import ReactTable from "react-table";

export default class DetalhesPedido extends Component {
  renderMetodoPagamento = (pedido) => {
    if (pedido.metodo_pagamento.tipo === "dinheiro") {
      if (pedido.detalhes_pagamento.troco) {
        return "Dinheiro com troco";
      } else {
        return "Dinheiro sem troco";
      }
    } else if (pedido.metodo_pagamento.tipo === "debito") {
      return `Débito - ${pedido.metodo_pagamento.descricao}`;
    } else if (pedido.metodo_pagamento.tipo === "credito") {
      return `Crédito - ${pedido.metodo_pagamento.descricao}`;
    }
  };

  convertToPeso = (peso) => {
    if (peso < 1) {
      return (
        parseFloat(peso * 1000)
          .toFixed(0)
          .toString()
          .replace(".", ",") + "g"
      );
    } else {
      return parseFloat(peso).toFixed(2).toString().replace(".", ",") + "Kg";
    }
  };

  formatPreco = (valor) => {
    return parseFloat(valor).toFixed(2).replace(".", ",");
  };

  render() {
    return (
      <div id="detalhes-pedido">
        <div style={{ float: "right" }}>
          <PDFDownloadLink
            document={<PDFDetalhesPedido pedido={this.props.pedido} />}
            fileName={`detalhes-pedido-${this.props.pedido.codigo}.pdf`}
            style={{
              textDecoration: "none",
              padding: "10px",
              color: "white",
              backgroundColor: "#701B8C",
              border: "1px solid white",
            }}
          >
            Baixar PDF
          </PDFDownloadLink>
        </div>
        <br></br>
        <Row>
          <Col sm={6}>
            <ul>
              <li>
                <b>Data de Criação:</b>{" "}
                {moment(this.props.pedido.createdAt).format("l")}{" "}
                {moment(this.props.pedido.createdAt).format("LT")}
              </li>
              {this.props.pedido.agendado ? (
                <li>
                  <b>Data de Agendamento:</b>{" "}
                  {moment(this.props.pedido.dataAgendamento).format("l")}{" "}
                  {moment(this.props.pedido.dataAgendamento).format("LT")}
                </li>
              ) : null}
              <li>
                <b>Ultima Atualização:</b>{" "}
                {moment(this.props.pedido.updateStatusAt).format("l")}{" "}
                {moment(this.props.pedido.updateStatusAt).format("LT")}
              </li>
              <li>
                <b>Código de Segurança:</b>{" "}
                {this.props.pedido.codigo_seguranca
                  ? this.props.pedido.codigo_seguranca
                  : null}
              </li>
              <li>
                <b>Cliente:</b>{" "}
                {this.props.pedido.cliente
                  ? this.props.pedido.cliente.nome
                  : null}
              </li>
              {this.props.pedido?.cliente?.cnpj ? (
                <li>
                  <b>CNPJ:</b> {this.props.pedido.cliente.cnpj}
                </li>
              ) : null}
              {this.props.pedido?.cliente?.usuario ? (
                <li>
                  <b>Email:</b> {this.props.pedido.cliente.usuario.email}
                </li>
              ) : null}
              <li>
                <b>Telefone:</b>{" "}
                {this.props.pedido.cliente
                  ? this.props.pedido.cliente.telefone
                  : null}
              </li>
              {this.props.pedido.entregador ? (
                <li>
                  <b>Entregador:</b> {this.props.pedido.entregador.nome}
                </li>
              ) : null}
              <li>
                <b>Método de Pagamento:</b>{" "}
                {this.renderMetodoPagamento(this.props.pedido)}
              </li>
              {this.props.pedido.numeroSacolas ? (
                <li>
                  <b>Número de Sacolas:</b> {this.props.pedido.numeroSacolas}
                </li>
              ) : null}
              <li>
                <b>Endereço do Cliente: </b>
                {this.props.pedido.endereco_cliente
                  ? this.props.pedido.endereco_cliente.bairro
                  : null}
                , rua{" "}
                {this.props.pedido.endereco_cliente
                  ? this.props.pedido.endereco_cliente.rua
                  : null}
                , numero{" "}
                {this.props.pedido.endereco_cliente
                  ? this.props.pedido.endereco_cliente.numero
                  : null}
                <br />
                Complemento:{" "}
                {this.props.pedido.endereco_cliente
                  ? this.props.pedido.endereco_cliente.complemento
                  : null}
                <br />
              </li>
            </ul>
          </Col>
          <Col sm={6}>
            <ul>
              {this.props.pedido.detalhes_pagamento.dinheiro_pago_cliente ? (
                <li>
                  <b>Valor pago pelo cliente:</b> R${" "}
                  {parseFloat(
                    this.props.pedido.detalhes_pagamento.dinheiro_pago_cliente
                  )
                    .toFixed(2)
                    .toString()
                    .replace(",", ".")}
                </li>
              ) : null}
              <li>
                <b>Valor Total:</b> R${" "}
                {parseFloat(this.props.pedido.valor_total)
                  .toFixed(2)
                  .toString()
                  .replace(",", ".")}
              </li>
              {this.props.pedido.detalhes_desconto?.cupom ? (
                <li>
                  <b>Cupom:</b>{" "}
                  {this.props.pedido.detalhes_desconto?.cupom?.codigo?.toUpperCase()}
                </li>
              ) : null}
              {this.props.pedido.detalhes_desconto?.cupom ? (
                <li>
                  <b>Tipo do desconto:</b>{" "}
                  {this.props.pedido.detalhes_desconto?.cupom?.tipo_desconto?.toUpperCase()}
                </li>
              ) : null}
              {this.props.pedido.detalhes_desconto?.cupom ? (
                <li>
                  <b>Valor do cupom:</b> R${" "}
                  {this.props.pedido.detalhes_desconto?.cupom?.tipo_desconto ===
                  "frete_gratis"
                    ? parseFloat(
                        this.props.pedido.detalhes_pagamento.frete_inicial || 0
                      )
                        .toFixed(2)
                        .toString()
                        .replace(",", ".")
                    : parseFloat(
                        this.props.pedido.detalhes_desconto?.cupom
                          ?.valor_desconto
                      )
                        .toFixed(2)
                        .toString()
                        .replace(",", ".")}
                </li>
              ) : null}
              <li>
                <b>Subtotal:</b> R${" "}
                {parseFloat(this.props.pedido.detalhes_pagamento.subtotal)
                  .toFixed(2)
                  .toString()
                  .replace(",", ".")}
              </li>
              {this.props.pedido.detalhes_pagamento.troco ? (
                <li>
                  <b>Troco:</b> R${" "}
                  {parseFloat(this.props.pedido.detalhes_pagamento.troco)
                    .toFixed(2)
                    .toString()
                    .replace(",", ".")}
                </li>
              ) : null}
              <li>
                <b>Frete:</b> R${" "}
                {parseFloat(this.props.pedido.detalhes_pagamento.frete)
                  .toFixed(2)
                  .toString()
                  .replace(",", ".")}
              </li>
              {this.props.pedido.detalhes_pagamento.valor_taxa_servico ? (
                <li>
                  <b>Taxa serviço:</b> R${" "}
                  {parseFloat(
                    this.props.pedido.detalhes_pagamento.valor_taxa_servico
                  )
                    .toFixed(2)
                    .toString()
                    .replace(",", ".")}
                </li>
              ) : null}
              <li>
                <b>Peso:</b>{" "}
                {parseFloat(this.props.pedido.peso_total)
                  .toFixed(2)
                  .toString()
                  .replace(",", ".")}{" "}
                Kg
              </li>
              <li>
                <b>Qtd. produtos: </b>
                {parseInt(this.props.pedido.itens.length)}
              </li>
              <li>
                <b>Qtd. produtos trocados: </b>
                {parseInt(this.props.pedido.itens_trocados.length)}
              </li>
              <li>
                <b>Qtd. produtos retirados: </b>
                {parseInt(this.props.pedido.itens_retirados.length)}
              </li>
              <li>
                <b>Qtd. produtos peso alterado: </b>
                {parseInt(this.props.pedido.itens_peso_alterado.length)}
              </li>
              <li>
                <b>Qtd. produtos adicionados: </b>
                {parseInt(this.props.pedido.itens_adicionados_separacao.length)}
              </li>
            </ul>
          </Col>
        </Row>
        <Row>
          <Col>
            <ul>
              <li>
                <p style={{ margin: 0 }}>
                  <b>Observações do cliente: </b>
                </p>
                <p style={{ margin: 0 }}>
                  {this.props.pedido.opcao_falta_estoque?.observacao ||
                    "Não informado"}
                </p>
              </li>
            </ul>
          </Col>
          <Col>
            <ul>
              <li>
                <p style={{ margin: 0 }}>
                  <b>Produtos não encontrados pelo cliente: </b>
                </p>
                <p style={{ margin: 0 }}>
                  {this.props.pedido.produtos_nao_encontrados ||
                    "Não informado"}
                </p>
              </li>
            </ul>
          </Col>
        </Row>
        <Row>
          <Col>
            <ul>
              <li>
                <b>Solicitação do cliente atendida?: </b>
                {this.props.pedido.solicitacao_cliente_atendida ? "Sim" : "Não"}
              </li>
            </ul>
          </Col>
          <Col>
            <ul>
              <li>
                <b>Nome do separador: </b>
                {this.props.pedido.nome_separador || "Não informado"}
              </li>
            </ul>
          </Col>
        </Row>
        <h4>Itens do Pedido:</h4>
        <TBLProdutos
          data={this.props.pedido.itens}
          numRows={10}
          isItemPedido={true}
          height={432}
          showAcoes={false}
        ></TBLProdutos>
        {this.props.pedido.itens_adicionados_separacao.length ? (
          <div>
            <br></br>
            <h4>Itens adicionados:</h4>
            <ReactTable
              data={this.props.pedido.itens_adicionados_separacao}
              columns={[
                {
                  Header: "SKU",
                  accessor: "sku",
                },
                {
                  Header: "Produto",
                  accessor: "nome",
                },
                {
                  Header: "Preço unitário",
                  accessor: "preco_unitario",
                  Cell: (props) => (
                    <span>
                      {props.value
                        ? "R$ " + this.formatPreco(props.value)
                        : "-"}
                    </span>
                  ),
                  className: "right",
                },
                {
                  Header: "Preço total",
                  accessor: "preco_total",
                  Cell: (props) => (
                    <span>
                      {props.value
                        ? "R$ " + this.formatPreco(props.value)
                        : "-"}
                    </span>
                  ),
                  className: "right",
                },
                {
                  Header: "Quantidade",
                  accessor: "quantidade",
                  Cell: (props) => (
                    <span>
                      {props.value ? this.formatPreco(props.value) : "-"}
                    </span>
                  ),
                  className: "right",
                },
                {
                  Header: "Tipo da embalagem",
                  accessor: "tipo_embalagem",
                  className: "right",
                },
              ]}
              resizable
              style={{
                height: this.props.height || 372,
                maxHeight: 372,
              }}
              previousText="Anterior"
              nextText="Próximo"
              loadingText="Carregando produtos..."
              noDataText="Nenhum produto encontrado!"
              pageText="Página"
              ofText="de"
              rowsText="linhas"
            />
          </div>
        ) : null}
      </div>
    );
  }
}
